import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AppState {
  isInitializingApp: boolean;
  showSudoBanner: boolean;
  obfuscateSensitiveData: boolean;
  sensitiveDataProperties: string[];
}

const initialState: AppState = {
  isInitializingApp: true,
  showSudoBanner: true,
  obfuscateSensitiveData: false,
  sensitiveDataProperties: [],
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setIsInitializingApp: (state, action: PayloadAction<boolean>) => {
      state.isInitializingApp = action.payload;
    },
    setShowSudoBanner: (state, action: PayloadAction<boolean>) => {
      state.showSudoBanner = action.payload;
    },
    setObfuscateSensitiveData: (state, action: PayloadAction<boolean>) => {
      state.obfuscateSensitiveData = action.payload;
    },
    setSensitiveDataProperties: (state, action: PayloadAction<string[]>) => {
      state.sensitiveDataProperties = action.payload;
    },
  },
});

export const {
  setIsInitializingApp,
  setShowSudoBanner,
  setObfuscateSensitiveData,
  setSensitiveDataProperties,
} = appSlice.actions;
export default appSlice.reducer;
